module.exports = __webpack_public_path__ + "static/media/kroppstemperatur.408c2a83.mp3";